module.exports = __webpack_public_path__ + "img/ico_question_mark_blue.2ec076cd.svg";